import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ServiceSocialGroup} from './service-social-group.model';
import * as ServiceSocialGroupActions from './service-social-group.actions';

export const serviceSocialGroupsFeatureKey = 'serviceSocialGroups';

export interface State extends EntityState<ServiceSocialGroup> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceSocialGroup> = createEntityAdapter<ServiceSocialGroup>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceSocialGroupActions.addServiceSocialGroup,
    (state, action) => adapter.addOne(action.serviceSocialGroup, state)
  ),
  on(ServiceSocialGroupActions.upsertServiceSocialGroup,
    (state, action) => adapter.upsertOne(action.serviceSocialGroup, state)
  ),
  on(ServiceSocialGroupActions.addServiceSocialGroups,
    (state, action) => adapter.addMany(action.serviceSocialGroups, state)
  ),
  on(ServiceSocialGroupActions.upsertServiceSocialGroups,
    (state, action) => adapter.upsertMany(action.serviceSocialGroups, state)
  ),
  on(ServiceSocialGroupActions.updateServiceSocialGroup,
    (state, action) => adapter.updateOne(action.serviceSocialGroup, state)
  ),
  on(ServiceSocialGroupActions.updateServiceSocialGroups,
    (state, action) => adapter.updateMany(action.serviceSocialGroups, state)
  ),
  on(ServiceSocialGroupActions.deleteServiceSocialGroup,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceSocialGroupActions.deleteServiceSocialGroups,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceSocialGroupActions.loadServiceSocialGroups,
    (state, action) => adapter.setAll(action.serviceSocialGroups, state)
  ),
  on(ServiceSocialGroupActions.clearServiceSocialGroups,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
